<template>
  <BigContainer>
    <div class="mx-auto max-w-[560px] px-2 sm:px-4">
      <SurfaceWell>
        <SectionCard flush overflow-hidden>
          <div class="p-5 sm:p-7 lg:p-8">
            <slot />
          </div>

          <template #footer>
            <p class="text-center text-sm text-gray-500 dark:text-gray-400">
              {{ switchPrompt }}
              <NuxtLink
                :to="switchTo"
                class="font-semibold text-amber-600 hover:underline dark:text-amber-400"
              >
                {{ switchLabel }}
              </NuxtLink>
            </p>
          </template>
        </SectionCard>
      </SurfaceWell>
    </div>
  </BigContainer>
</template>

<script setup lang="ts">
/** Shared focused card composition for the website's guest authentication pages. */
defineProps<{
  switchPrompt: string
  switchLabel: string
  switchTo: string
}>()
</script>
